/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CreditLedgerExportStatusResponseStatus } from './creditLedgerExportStatusResponseStatus';

export interface CreditLedgerExportStatusResponse {
  job_id: string;
  status: CreditLedgerExportStatusResponseStatus;
  download_url?: string | null;
  row_count?: number | null;
  truncated?: boolean;
  error?: string | null;
}
